import {React, useState,useEffect} from 'react';
import { getAllContactsByPartner} from '../../api/axios';
import { Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import CmsCircularProgress from '../../Components/Common/CircularProgress';
import styled from "styled-components";
import { showToast } from '../../Utills/toast';
import CustomTable from '../../Components/Common/DataTable/DataTable';
import { text } from '@fortawesome/fontawesome-svg-core';

function Preview() {
  const { partnerId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  
  const fetchContacts = async () => {
    setIsLoading(true);
    try {
      const res = await getAllContactsByPartner(partnerId);
      const contactData = res.data.data;
      setData(contactData);
    } catch (err) {
     showToast({
      type: 'error',
      message: err.response.data.message || 'Failed to fetch contacts. Please try again.',
     });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  const handleEditClick = (id) => {
    navigate(`update/${id}`);
    console.log('clicked');
  }

  const columns = [
    {
      text: "Contact ID",
      width: "105px"
    },
    {
      text: "Phone number",
      width: "132px"
    },
    {
      text: "Mailing address",
      width: "142px"
    },
    {
      text: "Email address",
      width: "180px"
    },
    {
      text: "Header paragraph",
      width: "160px"
    },
    {
     text: 'Action',
     width: "100px"
    }
  ];
  const rows = [];

  if(Array.isArray(data) && data.length > 0) {
    const item = data[0];
    rows.push([item.id, item.phoneNo, item.mailing_address, item.email_address, item.header_paragraph,(
     <div className='d-flex justify-content-center'>
       <Button variant="primary" className='m-0 w-auto' onClick={() => handleEditClick(item.id)}>Edit</Button>
     </div>
   )]);
  }

  return (
    <>
    {isLoading ? <CmsCircularProgress/> :
    <TableWrapper>
      <CustomTable columns={columns} rows={rows} />
  </TableWrapper>
      }
    </>
  );
}

export default Preview;

const TableWrapper = styled.div`
 overflow-x: auto;
    max-width: 100%;
`;